import CSS from "../static/css/ThemeDetailModalBtnContainer.module.css"
import { photoProductTypeCodeType, themaBookDetailListInterface } from "../static/interface/themeBook.interface";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { callAxios, customToast, dev_console, imageFilesUpload, imageUploadManagerClass2, isSuccess, printStateMsg, updateHtmlElementAttributes, whoAmI } from "../../../Common/ts/commonTools";
import LoopAnimationModal from "../../../Component/Elements/LoopAnimationModal/LoopAnimationModal";
import { chunkImageUploadDataInterface, uploadRequestfileDataInterface } from "../../../Common/interface/Common.interface";
import Button from "../../../Component/Elements/Button/Normal/Button";
import { backPointUrlManagerClass } from "../../../Common/ts/appTools";
import { sethemeManagerPageQueryParams } from "../static/ts/ThemeBook.tools";
import { FILE_USAGE_CD } from "../../../CustomerPage/ProductManufacturing/static/interface/ProductItemPhoto.interface";

const imageUploadManager = new imageUploadManagerClass2();

const backPointUrlManager = new backPointUrlManagerClass();

const ThemeDetailModalBtnContainer = (
    {
        // themeData,

        theme_id,
        office_id,
        group_id,
        photo_id,
        brand_id,
        detail_product_id,
        type,
        upload_file_pk,

        isInEditPage,
        // removedImageUrlListRef,
        mainContent,
        closeModalHandler,
        uploadedThumbnailFile,
        imgFiles,
    }:{
        // themeData:themaBookDetailListInterface;

        theme_id: number;
        office_id: number;
        group_id: number;
        photo_id: number;
        brand_id: number;
        detail_product_id: number;
        type: photoProductTypeCodeType;
        upload_file_pk: number;

        isInEditPage: boolean;
        // removedImageUrlListRef?: React.MutableRefObject<string[]>
        mainContent?: string;
        closeModalHandler?: React.MouseEventHandler<HTMLButtonElement>;
        uploadedThumbnailFile: File | null;
        imgFiles?: File[];
    }
) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [URLSearchParams, SetURLSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const location = useLocation();

    const l_back_point_url = useMemo(() => backPointUrlManager.getBackPointUrlAndDecode(URLSearchParams) || "/themeBook", [URLSearchParams]);

    const editBtnHandler = () => {

        if(!whoAmI.isAllEmployee()){
            customToast.error({
                msg: "작성 권한이 없습니다.",
                toastId: "admin_only"
            });

            return;
        }

        const l_themeUrlSearchParams = sethemeManagerPageQueryParams({
            type: type,
            office_id: office_id,
            photo_id: photo_id,
            thema_id: theme_id,
        })

        const m_url = backPointUrlManager.addSelfAddBackPointQueryParams({
            url: `/ThemeBookManagement?${l_themeUrlSearchParams}`,
            location
        })

        navigate(m_url, {
            state: {
                theme_id: theme_id,
                office_id: office_id,
                group_id: group_id,
                photo_id: photo_id,
                brand_id: brand_id,
                detail_product_id: detail_product_id,
                type: type,
            }
        });
    }

    // 저장
    const handleOnUploadContent = async () => {
        if(isLoading){
            alert("저장 작업이 진행 중입니다.");
            return ;
        }

        if(!whoAmI.isAllEmployee()){
            customToast.error({
                msg: "작성 권한이 없습니다.",
                toastId: "admin_only"
            });

            return;
        }

        if(!(!!mainContent) || mainContent.length === 0){
            if(!window.confirm("본문 내용이 작성되지 않았습니다.\n\n본문이 없을 경우 고객에게 노출되지 않습니다.\n\n이대로 저장하시겠습니까?")){
                return ;
            }
        }else{
            if((!window.confirm("저장하시겠습니까?"))){
                return ;
            }
        }

        setIsLoading(true);

        dev_console.log("brand_id ===>", brand_id);
        dev_console.log("theme_id ===>", theme_id);
        dev_console.log("upload_file_pk ===>", upload_file_pk);

        try{
            // 테마북 상세 페이지 내용
            let new_mainContent = mainContent;

            // // // 테마북 상세페이지에 올라간 기존 이미지 삭제
            // await imageUploadManager.FileDataClear({
            //     brand_id: brand_id,
            //     file_usage_cd: Number(FILE_USAGE_CD.THEME_BOOK_DETAIL_PAGE_IMAGE),
            //     data_pk: theme_id,
            //     is_all_clear: 1,
            // })

            // 새로운 파일이 존재하는 경우 이미지 업로드 처리
            if(imgFiles && imgFiles.length > 0){
                interface imageUploadResultInterface {
                    upload_file_pk: number;
                    fileCount: number;
                    fileSizeTotal: number;
                    totalFileSize: number;
                    album_save_id: number;
                    uploadedFileInfoArr: {
                        file_name: string;
                        file_size: number;
                        upload_file_detail_pk: number;
                        file_hash: string;
                    }[];
                }

                const imageUploadResult = await imageUploadManager.FileUploadR2Chunk(
                    [imgFiles],
                    Number(brand_id),
                    {
                        file_usage_cd: Number(FILE_USAGE_CD.THEME_BOOK_DETAIL_PAGE_IMAGE),
                        data_pk: theme_id,
                        is_allow_overlap: 1,
                        upload_file_pk: upload_file_pk,
                        is_add: upload_file_pk > 0 ? 1 : 0,
                    }
                ) as imageUploadResultInterface;

                // 테마북 본문에서 img 테그에 대해 data-file-hash 속성값을 key로 탐색하여 data-upload-file-detail-pk 속성값을 업데이트
                const updatedContent = updateHtmlElementAttributes(
                    mainContent!,
                    "img",
                    "data-file-hash",
                    "data-upload-file-detail-pk",
                    imageUploadResult.uploadedFileInfoArr.map(file => ({
                        matchValue: file.file_hash,
                        newValue: file.upload_file_detail_pk,
                    }))
                );

                // dev_console.log("updatedContent ===>", updatedContent);

                new_mainContent = updatedContent;
            }


            const thema_book_content_update_config = {
                detail_product_option_id: theme_id,
                content: new_mainContent,
            }

            const thema_book_content_update_url = "api/v3/detail-product/theme/content/save";

            const thema_book_content_update_response = await callAxios.api({
                url: thema_book_content_update_url,
                method: "post",
                data: thema_book_content_update_config,
            })

            if(thema_book_content_update_response.status !== 200){
                throw new Error("테마 상세페이지 정보 저장에 실패했습니다.");
            }

            if(thema_book_content_update_response.data.status.code !== 200){
                throw new Error("테마 상세페이지 정보 저장에 실패했습니다.");
            }

            // 썸네일 업로드 처리(ver2)
            if(!!uploadedThumbnailFile){
                // 기존 썸네일 제거
                await imageUploadManager.FileDataClear({
                    brand_id: brand_id,
                    file_usage_cd: Number(FILE_USAGE_CD.THEME_PHOTO),
                    data_pk: theme_id,
                    is_all_clear: 1,
                })

                // 새로운 썸네일 업로드
                imageUploadManager.FileUploadR2Chunk(
                    [[uploadedThumbnailFile]],
                    Number(brand_id),
                    {
                        file_usage_cd: Number(FILE_USAGE_CD.THEME_PHOTO),
                        data_pk: theme_id,
                        is_allow_overlap: 1,
                    }
                )
            }

            customToast.info({
                msg: "썸네일 이미지를 변경하신 경우에는 약 1분뒤에 변경된 썸네일 이미지가 적용됩니다."
            })

            navigate(l_back_point_url, {
                state: {
                    theme_id: theme_id
                }
            });

        }catch(error){
            dev_console.error(error);
            customToast.error({msg: `${(error as Error).message}`});
        }finally{
            setIsLoading(false);
        }
    }

    const deleteBtnHandler = () => {
        if(window.confirm("게시글이 삭제됩니다.\n\n삭제를 진행하시겠습니까?")){
            const config = {
                type: type,
                content: "",
                thema_id: theme_id
            }

            dev_console.log("삭제 요청 ===>", config);

            setIsLoading(true);
            const thema_book_content_update = "api/v3/customers/thema-book-content-update";

            callAxios.api({
                url: thema_book_content_update,
                method: "post",
                data: config,
            })
            .then(async (response) => {
                dev_console.log(thema_book_content_update);
                dev_console.log(response);

                if(isSuccess(response)){
                    navigate(l_back_point_url);
                }else{
                    printStateMsg(response);
                    customToast.error({msg: "게시글 삭제에 실패했습니다."});
                }
            })
            .catch((error) => {
                dev_console.error(error);
                customToast.error({msg: "게시글 삭제에 실패했습니다."})
            })
            .finally(() => {
                setIsLoading(false);
            })
        }
    }

    const cancelHandler = () => {
        if(window.confirm("저장하지 않은 내용들은 반영되지 않습니다.")){

            navigate(l_back_point_url, {
                state: {
                    theme_id: theme_id
                }
            });

            // const addedImageList = getDifferentImageUrls({
            //     origin: themeData?.content || "",
            //     newContent: mainContent || "",
            //     conditions: "added",
            // });

            // removeS3ImageList(addedImageList)
            // .then(() => {
            //     dev_console.log("all remove clear!");
            // })
            // .catch((error) => {
            //     dev_console.error(error);
            // })
            // .finally(() => {
            //     navigate("/themeBook", {
            //         state: {
            //             theme_id: themeData.thema_id
            //         }
            //     });
            // })
        }
    }

    if(isInEditPage){
        return(
            <div className={CSS.l_theme_detail_modal_btn_container_main}>
                    <Button
                        onClick={handleOnUploadContent}
                        size={"size1"}
                        preset={"save"}
                    >
                        저장
                    </Button>

                    <Button
                        onClick={cancelHandler}
                        size={"size1"}
                        preset={"cancel"}
                    >
                        취소
                    </Button>

                    <Button
                        onClick={deleteBtnHandler}
                        size={"size1"}
                        preset={"delete"}
                    >
                        삭제
                    </Button>

                    <LoopAnimationModal
                        isModalOpen={isLoading}
                    >
                    </LoopAnimationModal>
            </div>
        )
    }else{
        return(
            <div className={CSS.l_theme_detail_modal_btn_container_main}>
                {
                    whoAmI.isAllEmployee()
                    &&  <Button
                            onClick={editBtnHandler}
                            size={"size1"}
                            preset={"edit"}
                        >
                            수정
                        </Button>
                }
                <Button
                    onClick={closeModalHandler}
                    size={"size1"}
                >
                    닫기
                </Button>
            </div>
        )
    }
}

export default ThemeDetailModalBtnContainer;